import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Smile = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm3.493-13a1.494 1.494 0 11-.001 2.987A1.494 1.494 0 0115.493 9zm-4.301 6.919a4.108 4.108 0 001.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117a6.027 6.027 0 01-1.619 1.621 6.003 6.003 0 01-2.149.904 6.116 6.116 0 01-2.414-.001 5.919 5.919 0 01-2.148-.903 6.078 6.078 0 01-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 002.022 1.093zM8.5 9a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 018.5 9z"
  }));
});
Smile.displayName = 'Smile';
export var SmileDimensions = {
  height: 24,
  width: 24
};